import type { SalesAndResourcesSimulationToolsContent } from '../types/SalesAndResourcesSimulationToolsContent';

export function createSalesAndResourcesSimulationToolsContentPlaceholder(): SalesAndResourcesSimulationToolsContent {
    return {
        pageTitle: { kind: 'plainText', key: '', content: '' },
        pageSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
        pageTitleBackgroundImage: { kind: 'image' as const, key: '', imageUrl: '' },
        Overview: {
            title: { kind: 'plainText', key: '', content: '' },
            Tools: {
                CapacitorAnalysis: {
                    toolTitle: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                    toolSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
                    toolImage: { kind: 'image', key: '', imageUrl: '' },
                },
                FilmLifetime: {
                    toolTitle: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                    toolSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
                    toolImage: { kind: 'image', key: '', imageUrl: '' },
                },
                CeramicAging: {
                    toolTitle: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                    toolSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
                    toolImage: { kind: 'image', key: '', imageUrl: '' },
                },
                InductorAnalysis: {
                    toolTitle: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                    toolSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
                    toolImage: { kind: 'image', key: '', imageUrl: '' },
                },
                CapacitorLifetime: {
                    toolTitle: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                    toolSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
                    toolImage: { kind: 'image', key: '', imageUrl: '' },
                },
                FITAnalysis: {
                    toolTitle: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                    toolSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
                    toolImage: { kind: 'image', key: '', imageUrl: '' },
                },
            },
            PreBuiltProjects: {
                title: { kind: 'plainText', key: '', content: '' },
                CapacitorDCBiasComparison: {
                    projectTitle: { kind: 'plainText', key: '', content: '' },
                    projectImage: { kind: 'image', key: '', imageUrl: '' },
                    linkButton: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                },
                ESRComparison: {
                    projectTitle: { kind: 'plainText', key: '', content: '' },
                    projectImage: { kind: 'image', key: '', imageUrl: '' },
                    linkButton: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                },
                TemperatureBiasEffect: {
                    projectTitle: { kind: 'plainText', key: '', content: '' },
                    projectImage: { kind: 'image', key: '', imageUrl: '' },
                    linkButton: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                },
                PowerInductorTemperatureRise: {
                    projectTitle: { kind: 'plainText', key: '', content: '' },
                    projectImage: { kind: 'image', key: '', imageUrl: '' },
                    linkButton: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                },
                CeramicAging: {
                    projectTitle: { kind: 'plainText', key: '', content: '' },
                    projectImage: { kind: 'image', key: '', imageUrl: '' },
                    linkButton: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                },
                FilmCapacitorLifeCalculator: {
                    projectTitle: { kind: 'plainText', key: '', content: '' },
                    projectImage: { kind: 'image', key: '', imageUrl: '' },
                    linkButton: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                },
                AluminumCapacitorLifeCalculator: {
                    projectTitle: { kind: 'plainText', key: '', content: '' },
                    projectImage: { kind: 'image', key: '', imageUrl: '' },
                    linkButton: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                },
                WideBandwidth: {
                    projectTitle: { kind: 'plainText', key: '', content: '' },
                    projectImage: { kind: 'image', key: '', imageUrl: '' },
                    linkButton: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                },
                CapacitorTemperatureRise: {
                    projectTitle: { kind: 'plainText', key: '', content: '' },
                    projectImage: { kind: 'image', key: '', imageUrl: '' },
                    linkButton: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                },
            },
            FITCalculator: {
                pageTitle: { kind: 'plainText', key: '', content: '' },
                pageSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
                pageTitleBackgroundImage: { kind: 'image', key: '', imageUrl: '' },
                Software: {
                    title: { kind: 'plainText', key: '', content: '' },
                    subtitle: { kind: 'plainMultilineText', key: '', content: '' },
                    linkButton: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                    backgroundImage: { kind: 'image', key: '', imageUrl: '' },
                },
                Manual: {
                    title: { kind: 'plainText', key: '', content: '' },
                    subtitle: { kind: 'plainMultilineText', key: '', content: '' },
                    linkButton: { kind: 'externalLink', key: '', linkText: '', linkUrl: '' },
                    backgroundImage: { kind: 'image', key: '', imageUrl: '' },
                },
            },
        },
        Resources: {
            title: { kind: 'plainText', key: '', content: '' },
        },
    };
}
